import React, { useState } from 'react';
import { format, subMonths, subYears, startOfMonth, endOfMonth } from 'date-fns';

export const DateFilter = ({ onFilterChange }) => {
    const today = format(new Date(), 'yyyy-MM-dd');
    
    const [filterType, setFilterType] = useState('all');
    const [customRange, setCustomRange] = useState({
        from: '',
        to: today
    });

    const handleFilterTypeChange = (type) => {
        setFilterType(type);

        let dateRange = {};
        const today = new Date();

        switch (type) {
            case 'month':
                dateRange = {
                    from: format(subMonths(today, 1), 'yyyy-MM-dd'),
                    to: format(today, 'yyyy-MM-dd')
                };
                break;
            case 'year':
                dateRange = {
                    from: format(subYears(today, 1), 'yyyy-MM-dd'),
                    to: format(today, 'yyyy-MM-dd')
                };
                break;
            case 'custom':
                dateRange = customRange;
                break;
            default:
                dateRange = { from: '', to: '' };
        }

        onFilterChange(type, dateRange);
    };

    const handleCustomRangeChange = (field, value) => {
        const newRange = { ...customRange, [field]: value };
        setCustomRange(newRange);
        if (filterType === 'custom') {
            onFilterChange('custom', newRange);
        }
    };

    return (
        <div className="mb-6 border p-3">
            <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">
                Published Date
            </h3>
            <div className="space-y-2">
                <label className="flex items-center space-x-2">
                    <input
                        type="radio"
                        checked={filterType === 'all'}
                        onChange={() => handleFilterTypeChange('all')}
                        className="form-radio text-primary-600"
                    />
                    <span className="text-sm text-gray-700">All dates</span>
                </label>
                <label className="flex items-center space-x-2">
                    <input
                        type="radio"
                        checked={filterType === 'month'}
                        onChange={() => handleFilterTypeChange('month')}
                        className="form-radio text-primary-600"
                    />
                    <span className="text-sm text-gray-700">Past month</span>
                </label>
                <label className="flex items-center space-x-2">
                    <input
                        type="radio"
                        checked={filterType === 'year'}
                        onChange={() => handleFilterTypeChange('year')}
                        className="form-radio text-primary-600"
                    />
                    <span className="text-sm text-gray-700">Past year</span>
                </label>
                <label className="flex items-center space-x-2">
                    <input
                        type="radio"
                        checked={filterType === 'custom'}
                        onChange={() => handleFilterTypeChange('custom')}
                        className="form-radio text-primary-600"
                    />
                    <span className="text-sm text-gray-700">Custom range</span>
                </label>

                {filterType === 'custom' && (
                    <div className="mt-3 space-y-2">
                        <div>
                            <label className="text-sm text-gray-600">From:</label>
                            <input
                                type="date"
                                value={customRange.from}
                                onChange={(e) => handleCustomRangeChange('from', e.target.value)}
                                className="w-full mt-1 px-2 py-1 text-sm border rounded"
                            />
                        </div>
                        <div>
                            <label className="text-sm text-gray-600">To:</label>
                            <input
                                type="date"
                                value={customRange.to}
                                onChange={(e) => handleCustomRangeChange('to', e.target.value)}
                                className="w-full mt-1 px-2 py-1 text-sm border rounded"
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};